<template>
	<div class="solve">
		<div class="solonlogy-top">
			<img src="../../static/img/solve.jpg"/>
		</div>
		<div class="sol-detail">
			<div class="sol-top-top">
				<h4>{{sol[0].title}}</h4>
				<div class="sol-line">	
				</div>
			</div>
			<div class="solinfo" v-html="news[0].Contentall">
				{{news[0].Contentall}}
           </div>
		</div>
	</div>
</template>

<script>
	export default{
		name : 'solve',
		data () {
			return {
				sol : [
				{id : 0 , imgsrc : 'static/img/solve.jpg' , title : '服务承诺'},
				],
				news:[],
			}
		},
		mounted(){
			this.getnews();
		},
		methods : {
			getnews(){
      			var that = this;
      			var conlist = [];
     				this.$http.post('http://www.gd-sc.net:9094',{table : 'contentall'},{emulateJSON: true}).then((response) => {
			        for(var i=0 ; i<response.body.recordset.length ; i++){
			        	if(response.body.recordset[i].Alltype == '服务承诺'){
			        		conlist.push(response.body.recordset[i])
			        	}
			        }
			        that.news = conlist;
			      })
     			},
		},
	}
</script>

<style>
	.solve{
		width: 100%;
		position: relative;
		clear: both;
		overflow: hidden;
	}
	.sol-detail{
		width: 80%;
		margin: 60px auto;
		position: relative;
		clear: both;
		text-align: left;		
	}
	.sol-line{
		width: 25px;
		height: 3px;
		position: absolute;
		background: #e01313;
		border-radius: 4px;
		top: 8px;
	}	
		.com-tit{
		width: 40%;
		position: absolute;
		clear: both;
		z-index: 3;
		top: 12vw;
	    left: 11vw;
	    text-align: left;
	    font-size: 22px;
	    color: #fff;
	}
	.com-tit img {
	    width: 4% !important;
	    margin-right: 23px;
	}
	.com-tit p{
		margin-top: 20px;
		font-size: 14px;
		line-height: 28px;
	}
	.com-tit b{
		font-size: 25px;
	    position: relative;
	    top: 3px;
	}
	.sol-top-top{
		width: 100%;
		border-bottom: 1px solid #ddd;
		position: relative;
		padding-bottom: 10px;
	}
	.sol-detail h4{
		font-weight: 700;
		margin-left: 50px;
		font-size: 22px;
	}	
	.solonlogy-top img{
		width: 100%;
	}
	.solinfo{
		position: relative;
		clear: both;
		padding: 2%;
	}
	.solinfo .redbg{
		font-weight: bold;
		color: red;
		line-height: 10px;
	}
	.solinfo p{
		color: #666666;
		line-height: 35px;
		margin: 20px auto;
		font-size: 18px;
		text-indent:2em;
	}
	.solinfo img{
		text-align: center;
	}
	.sol-singleimg{
		text-align: center;
		position: relative;
	}
	.sol-singleimg img{
		
	}
	.sol-detail h4.small-tit{
		text-align: center;
		width: 500px;
		margin: 50px auto 0;
		position: relative;
		color: #0066ef ;
		font-weight: 500;
		margin-bottom: 30px;
	}
	.solinfo p b{
		color: red;
	}
	.solinfo p.ggzyp{
		display: inline-block;
		width: 49%;
		position: relative;
		clear: both;
		margin: 10px 0;
	}
	.fwcnleft{
		float: left;
		width: 45%;
		margin-bottom: 60px;
	}
	.fwcnright img{
		float: right;
		width: 50%;
	}
</style>


// WEBPACK FOOTER //
// src/components/Service.vue